import React from 'react';
import { Shield, Mail } from 'lucide-react';

interface VerificationStatusProps {
  email: string;
  onResendVerification: () => Promise<void>;
  isResending?: boolean;
  error?: string | null;
}

export function VerificationStatus({
  email,
  onResendVerification,
  isResending = false,
  error = null
}: VerificationStatusProps) {
  return (
    <div className="rounded-lg bg-white p-6 shadow-lg">
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0">
          <Shield className="h-6 w-6 text-indigo-600" />
        </div>
        <h3 className="text-lg font-medium text-gray-900">Verify Your Email</h3>
      </div>
      
      <div className="mt-4">
        <p className="text-sm text-gray-600">
          We've sent a verification link to <strong>{email}</strong>.
          Please check your email and click the link to verify your account.
        </p>
        
        {error && (
          <div className="mt-2 text-sm text-red-600">
            {error}
          </div>
        )}
        
        <div className="mt-4 flex items-center justify-between">
          <button
            onClick={onResendVerification}
            disabled={isResending}
            className="inline-flex items-center text-sm text-indigo-600 hover:text-indigo-500"
          >
            <Mail className="h-4 w-4 mr-1" />
            {isResending ? 'Sending...' : 'Resend verification email'}
          </button>
        </div>
      </div>
    </div>
  );
}